<template>
  <nav class="mega-menu">
    <div class="mega-menu__categories">
      <div class="mega-menu__categories-list">
        <template v-for="area in areas">
          <router-link
            :key="area.id"
            class="mega-menu__categories-item"
            @click.native="$emit('closeMegaMenu')"
            :to="{ name: 'learning-area', params: { id: area.id } }"
          >
            <Passes :passName="area.name" :showTooltip="false" />
            <span class="mega-menu__categories-item--text">{{
              area.name
            }}</span>
          </router-link>
        </template>
        <router-link
          @click.native="$emit('closeMegaMenu')"
          :to="{ name: 'learning-paths' }"
          class="mega-menu__categories-item mega-menu__list-item-user"
          style="margin: 15px auto 0 auto"
        >
          <PathsIcon class="mega-menu__list-item-icon" />
          Learning Paths
        </router-link>
        <router-link
          v-if="isAuthenticated"
          @click.native="$emit('closeMegaMenu')"
          :to="{ name: 'user-dashboard', params: { mode: 'active-courses' } }"
          class="mega-menu__categories-item mega-menu__list-item-user"
        >
          <CoursesIcon class="mega-menu__list-item-icon" />
          Active Courses
        </router-link>
        <router-link
          v-if="isAuthenticated"
          @click.native="$emit('closeMegaMenu')"
          :to="{ name: 'user-dashboard', params: { mode: 'bookmarks' } }"
          class="mega-menu__categories-item mega-menu__list-item-user"
        >
          <BookmarksIcon class="mega-menu__list-item-icon" />
          My Bookmarks
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import PathsIcon from '@/assets/icons/navigation/learning_paths.svg'
import CoursesIcon from '@/assets/icons/navigation/active_courses.svg'
import BookmarksIcon from '@/assets/icons/navigation/my_bookmarks.svg'
import Passes from '@/components/properties/Passes.vue'

export default {
  name: 'DesktopMegaMenu',
  components: {
    PathsIcon: { ...PathsIcon, name: 'PathsIcon' },
    CoursesIcon: { ...CoursesIcon, name: 'CoursesIcon' },
    BookmarksIcon: { ...BookmarksIcon, name: 'BookmarksIcon' },
    Passes,
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    primaryAreas: {
      type: Array,
      required: true,
    },
    secondaryAreas: {
      type: Array,
      required: true,
    },
  },
  computed: {
    areas() {
      const { primaryAreas, secondaryAreas } = this
      return [...primaryAreas, ...secondaryAreas]
    },
  },
}
</script>

<style lang="scss">
.mega-menu {
  display: none;
  @include tablet {
    display: block;
    width: 100%;
    background: var(--menu-background);
  }
  &__categories {
    background: var(--menu-background);
    position: absolute;
    top: 90px;
    left: 0;
    width: 340px;
  }
  &__categories-item {
    color: var(--white);
    font-family: var(--font-bold);
    font-size: 22px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 15px 129px 15px 70px;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      border-left: 6px solid var(--orange);
      background: var(--black);
      text-decoration: underline;
    }
    &--text {
      margin: 0 0 0 15px;
    }
  }
  &__list-item-icon {
    fill: var(--menu-subcategory);
    margin: 0 20px 0 0;
    width: 24px;
    height: 20px;
  }
  &__list-item-user {
    font-size: 18px;
    color: var(--menu-subcategory);
    display: flex;
    align-items: center;
    padding: 15px 70px;
  }
}
</style>
